const domain = process.env ? `${process.env.SERVICE_URL}${process.env.API_PATH}` : '/api/v1';
export const server = process.env ? process.env.SERVICE_URL : '/';

const routes = {
  root: server,
  designer: {
    get: `${domain}/event/designer/`,
    update: `${domain}/event/designer/`,
    references: `${domain}/event/page/`,
    manager: `${domain}/event/manager/`,
  },
  playbill: {
    get: `${domain}/event/list/`,
    getEvents: `${domain}/event/main/`
  },
  editor: {
    get: `${domain}/editor/`,
  },
  user: {
    new: `${domain}/user/`,
    edit: `${domain}/user/edit/`,
    regforms: `${domain}/user/regforms/`,
    code: `${domain}/user/code/send/`,
    setPass: `${domain}/user/setpass/`,
    verify: `${domain}/user/code/verify/`,
    auth: `${domain}/user/auth/`,
    listener: `${domain}/user/listener/`,
    company: `${domain}/user/company/`,
    companyListener: `${domain}/user/company/listener/`, // @depricated
    listenerOther: `${domain}/user/listener/other/`,
    updateCompany: `${domain}/user/company/edit/`,
    avatar: `${domain}/user/avatar/`,
    verifyPromo: `${domain}/user/promo/verify/`,
    lead: `${domain}/user/lead/`,
    review: `${domain}/user/review`,
    certificate: `${domain}/user/certificate`,
    agreement: `${domain}/user/agreement`,
    errorlog: `${domain}/user/errorlog`,
  },
  subscribe: {
    get: `${domain}/subscribe/`,
    post: `${domain}/subscribe/`,
  },
};

export default routes;
